import { render, staticRenderFns } from "./ScheduledNotificationForm.vue?vue&type=template&id=a1f8d410&scoped=true"
import script from "./ScheduledNotificationForm.vue?vue&type=script&lang=js"
export * from "./ScheduledNotificationForm.vue?vue&type=script&lang=js"
import style0 from "./ScheduledNotificationForm.vue?vue&type=style&index=0&id=a1f8d410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f8d410",
  null
  
)

export default component.exports